/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Row, Popconfirm, Space, Button, Calendar, Tooltip, Dropdown } from 'antd';
import { red, volcano, gold, lime, green, cyan, blue, geekblue, purple, magenta, grey, } from '@ant-design/colors';
import { PlusOutlined, PushpinOutlined, StarFilled, ReloadOutlined, SettingOutlined, FullscreenOutlined, DownOutlined, CheckOutlined } from '@ant-design/icons';
import ProTable, { TableDropdown } from '@ant-design/pro-table';
import { pagization } from '../../api/api';
import { apiStaffList } from '../../api/staff';
import { apiRoleList } from '../../api/role';
import { apiOrganizationGet } from '../../api/organization';
import { PaginationPositionIcon, PicPreview } from '../../component/antd/antd';

class Staff extends Component{
    constructor(props){
        super(props);
        const columns = [
            {
                title: '确认',
                type: 'str',
                width: 48,
                dataIndex: 'Id',
                search: false,
                render: (text, record) => this.props.selectedRowKeys?.indexOf(record.Id) !== -1 ? <CheckOutlined style={{color: green[5]}} /> : undefined
            },
            {
                title: '头像',
                type: 'str',
                width: '10%',
                dataIndex: 'AvatarUrl',
                search: false,
                render: (text) => {
                    return <div className="staff-avatar"><img alt="" src={text}/></div>
                }
            },
            {
                title: '姓名',
                type: 'str',
                width: '20%',
                dataIndex: 'NickName',
                fieldProps: {
                    placeholder: "搜索"
                },
            },
            {
                title: '编号',
                type: 'str',
                width: '20%',
                dataIndex: 'SerialNumber',
                ellipsis: true,
                fieldProps: {
                    placeholder: "搜索"
                },
            },
            {
                title: '手机号',
                type: 'str',
                width: '15%',
                dataIndex: 'PhoneNum',
                fieldProps: {
                    placeholder: "搜索"
                },
            },
            {
                title: '操作',
                width: '20%',
                key: 'option',
                valueType: 'option',
                render: (_, record) => {
                    if (this.props.selectedRowKeys?.indexOf(record.Id) === -1) {
                        return [<Button key={record.Id} type="link" className="nopadding" onClick={() => {
                            let { onAdd } = this.props;
                            onAdd && onAdd([record])
                        }}>添加</Button>]
                    } else {
                        return [<Button key={record.Id} type="link" className="nopadding" onClick={() => {
                            let { onDel } = this.props;
                            onDel && onDel([record])
                        }}>删除</Button>]
                    }
                },
            },
        ];

        this.state = {
            data: [],
            columns: columns,
            paginationData: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            paginationConfig: {
                position: ['bottomRight'],
                showQuickJumper: true,
            },
        }
    }

    mkPageBody() {
        let { columns, paginationData, paginationConfig } = this.state;
        let operations = [
            <Button key="refresh" type="default" icon={<ReloadOutlined />} onClick={() => this.table.submit()}>刷新</Button>,
            <PaginationPositionIcon
                paginationConfig={paginationConfig}
                onChange={(key) => {
                    paginationConfig.position = [key]
                    this.setState({
                        paginationConfig: paginationConfig,
                    })
                }}
            />,
        ]

        return (
            <ProTable
                className="table-bind-staff"
                formRef={(ref) => this.table = ref}
                columns={columns}
                request={async (params, sorter, filter) => {
                    // 表单搜索项会从 pagination 传入，传递给后端接口。
                    console.group('request');
                    console.log("params:", params);
                    console.log("sorter:", sorter);
                    console.log("filter:", filter);
                    console.groupEnd();
                    
                    let rsp = await apiStaffList(pagization(params, sorter, filter, columns))
                    if (rsp.Status === 0) {
                        this.setState({
                            paginationData: {
                                current: params?.current,
                                pageSize: params?.pageSize,
                                total: rsp?.TotalNum,
                            },
                        })
                    }
                    return {
                        data: rsp?.RecordList || [],
                        total: rsp?.TotalNum,
                        success: true,
                    };
                }}
                rowSelection={{
                    getCheckboxProps: (record) => ({
                        Id: record.Id,
                    }),
                    alwaysShowAlert: true,
                }}
                tableAlertRender={({selectedRowKeys}) => {
                    return <Space size="small" style={{height: '32px'}}>
                        <span>已确认</span>
                        <span style={{ color: red[5] }}>{this.props.selectedRowKeys?.length || 0}</span>
                        <span >项，</span>
                        <span>待选择</span>
                        <span style={{ color: red[5] }}>{selectedRowKeys?.length || 0}</span>
                        <span>项</span>
                    </Space >
                }}
                tableAlertOptionRender={({ selectedRowKeys, selectedRows, onCleanSelected }) => {
                    return (selectedRowKeys?.length ?
                        <Space size={16}>
                            <Button className="nopadding" type="link" onClick={(e) => {
                                let { onAdd } = this.props;
                                onAdd && onAdd(selectedRows)
                                onCleanSelected(e)
                            }}>批量添加</Button>
                            <Button className="nopadding" type="link" onClick={(e) => {
                                let { onDel } = this.props;
                                onDel && onDel(selectedRows)
                                onCleanSelected(e)
                            }}>批量删除</Button>
                            {/* <Button className="nopadding" type="link" onClick={onCleanSelected}>取消选择</Button> */}
                        </Space> : undefined
                    );
                }}
                rowClassName={(record) => this.props.selectedRowKeys?.indexOf(record.Id) !== -1 ? "table-row-selected" : ""}
                rowKey="Id"
                pagination={{
                    ...paginationConfig,
                    ...paginationData,
                }}
                toolbar={{
                    // multipleLine: true,
                }}
                search={{ filterType: "light" }}
                dateFormatter="string"
                headerTitle="人员列表"
                options={{
                    density: true,
                    setting: true,
                    reload: false,
                    fullScreen: false,
                    search: false,
                }}
                toolBarRender={() => operations}
            />
        )
    }
    
    componentWillUnmount() {
        // 防止内存溢出
        this.setState = (state, callback) => {
            return;
        };
       
    }

    componentDidMount() {
        let { columns } = this.state;
        let fun = async () => {
            let roleData = [];
            let nowColumns = [];
            let rsp2 = await apiRoleList({ PageNum: 1, PageSize: 1000, }, { ignoreError: true })
            if (rsp2.Status === 0) {
                let roleData = rsp2?.RecordList || []
                let valueEnum = {}
                if (roleData !== undefined) {
                    roleData.forEach(r => {
                        valueEnum[r.Id] = {
                            text: r.Name
                        };
                    })
                    nowColumns = [
                        ...columns.slice(0, 5),
                        {
                        title: '角色',
                            type: 'intEnumMultiple',
                            width: '10%',
                            dataIndex: 'RoleId',
                            valueType: 'select',
                            fieldProps: {
                                mode: 'multiple',
                            },
                            valueEnum: valueEnum,
                        },
                        ...columns.slice(5),
                    ]
                }
            }
            
            // 获取部门信息
            let rsp3 = await apiOrganizationGet({}, { ignoreError: true })
            let orgData = [];
            try {
                orgData = JSON.parse(rsp3?.Data || "[{\"key\": \"_\", \"children\": [], \"title\": \"总部\"}]");
            } catch (error) {
                console.error("parse json error", error);
            }
            let dataList = [];
            const generateList = data => {
                for (let node of data) {
                    dataList.push(node);
                    if (node.children) {
                        generateList(node.children);
                    }
                }
            };
            generateList(orgData);
            let orgValueEnum = {}
            dataList.forEach(r => {
                orgValueEnum[r.key] = {
                    text: r.title
                };
            })
            nowColumns = [
                ...nowColumns.slice(0, 6),
                {
                    title: '部门',
                    type: 'strEnumMultiple',
                    width: '10%',
                    dataIndex: 'Department',
                    fieldProps: {
                        mode: 'multiple',
                    },
                    valueType: 'select',
                    valueEnum: orgValueEnum,
                    render: (text, record) => {
                        return <div>{dataList.find(d => d.key === record?.Department)?.title || "-"}</div>
                    }
                },
                ...nowColumns.slice(6),
            ]

            this.setState({
                roleData: roleData,
                columns: nowColumns,
            })
        }
        fun()
    }

    render(){
        return (<div>
            {this.mkPageBody()}
        </div>)
    }
}

export default Staff;

